/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ParserAddModal from '../ParserAddModal';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
};

class ParserAddCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers');
  }

  render() {
    const { appId } = this.props;
    const { showAdd = false } = this.state;

    return (
      <div>
        <Link className={styles.card} onClick={() => this.setState({ showAdd: true })}>
          <span className="glyphicons glyphicons-plus" />
          <br />
          {this.intlMsg.msg('add')}
        </Link>
        <ParserAddModal
          appId={appId}
          show={showAdd}
          onHide={() => this.setState({ showAdd: false })}
        />
      </div>
    );
  }
}

ParserAddCard.propTypes = propTypes;

export default injectIntl(ParserAddCard);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserAddCard/index.jsx